import { IStudentDetailSchema } from "./hooks/schemas";

type IStudentDetail =
  | {
      lastName: string;
      firstName: string;
      gender: string;
      gradeId: number;
      sectionId: number;
    }
  | null
  | undefined;

const clearData: IStudentDetailSchema = {
  lastName: "",
  firstName: "",
  gender: "",
  gradeId: -1,
  sectionId: -1,
};

export { clearData };
export type { IStudentDetail };

